import React, {useContext, useEffect, useState} from "react";
// @ts-ignore
import {useHistory, useLocation, useParams} from "react-router-dom";
import '../RankingsAndLevelsComponent/RankingsAndLevels.css'
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import RankingsAndLevelsUtils from "../../services/RankingsAndLevelsUtils";
import TierGraphicsComponent from "./TierGraphicsComponent";


const TierGraphicsContainer: React.FC = () => {
    // @ts-ignore
    const {isLife, setIsLife}                    = useContext(RankingsAndLevelsContext);
    // @ts-ignore
    const {last10YearReports, allDataLoaded} = useContext(GlobalDataContext);

    let {yearCode, tierCode}    = useParams();
    let history                 = useHistory();
    let location                = useLocation();
    const MAX_BARS_PER_PAGE     = 7;

    const [chunkedCountries, setChunkedCountries]           = useState<any>([]);
    const [displayDataCountries, setDisplayDataCountries]   = useState<any>([]);
    const [maxGip, setMaxGip]                               = useState(1);

    const [pageSelected, setPageSelected]   = useState<number>(1);
    const [maxPage, setMaxPage]             = useState<number>(1);

    const handlePageChange = (pageMovement: number) => {
        const newPage = pageSelected + pageMovement;
        if (newPage < 1 || newPage > maxPage) {
            return;
        }
        setPageSelected(newPage);
        setDisplayDataCountries(chunkedCountries[newPage - 1])
    };

    const chunkCountries = (array: any, size: any) => {
        const chunked_arr = [];
        for (let index = 0; index < array.length; index += size) {
            chunked_arr.push(array.slice(index, size + index));
        }
        return chunked_arr;
    };

    const handleUnsortedCountries = (data: any) => {
        setPageSelected(1);
        setMaxPage(Math.ceil(data.length / MAX_BARS_PER_PAGE));
        const orderedCountries = data?.sort((a: any, b: any): number => b.gip - a.gip);
        const chunk = chunkCountries(orderedCountries, MAX_BARS_PER_PAGE);

        setMaxGip(Math.max(...orderedCountries.map((value: any) => value.gip)));
        setChunkedCountries(chunk);
        setDisplayDataCountries(chunk[0])
    };

    useEffect(() => {
        if (allDataLoaded) {
            const report = last10YearReports[yearCode];
            if (!report) {
                //fetch to backend and save in another var?
            } else {
                const data = RankingsAndLevelsUtils.getReportGips(report, tierCode, isLife);
                if(data?.length){
                    handleUnsortedCountries(data);
                }
            }
        }
    }, [allDataLoaded, yearCode, tierCode, isLife]);

    useEffect(() => {
        let baseUrl = `/rankings/${yearCode}/tiers/${tierCode}`;
        RankingsAndLevelsUtils.handleQueryParams(location, history, isLife, setIsLife, baseUrl);
    }, []);

    return (
        <TierGraphicsComponent
            isLife={isLife}
            yearCode={yearCode}
            pageSelected={pageSelected}
            handlePageChange={handlePageChange}
            maxPage={maxPage}
            displayDataCountries={displayDataCountries}
            maxGip={maxGip}
            firstPageLength={chunkedCountries[0]?.length || 0}
        />
    )
};

export default TierGraphicsContainer;
